const BzTreeItem = {
  props: {
    id: String
  },
  computed: {
    bzData () {
      return this.$store.getters['bzTree/getLeaf'](this.modelName, this.id)
    },
    children () {
      return this.bzData.children
    },
    modelName () {
      let tagname = this.$data.modelTag || this.$options._componentTag
      return this.$store.getters['bzTree/modelByTag'](tagname)
    },
    dataKey () {
      return this.compoundKey(this.modelName, this.id)
    },
    locale () {
      return this.$store.getters['localization/getLocale'](this.dataKey)
    },
    level () {
      return this.$store.getters['bzTree/getLevel'](this.modelName, this.id)
    }
  },
  methods: {
    tagByModel (model) {
      return this.$store.getters['bzTree/tagByModel'](model)
    },
    compoundKey (model, id) {
      return `${model}_${id}`
    },
    localized (field) {
      if (typeof this.bzData[field] === 'object') {
        return this.bzData[field][this.locale]
      } else {
        return this.bzData[field]
      }
    }
  }
}

export default BzTreeItem
/*
.article.row
  .col-12.paragraph
    .row
      .col-md-4.col-sm-12.paragraph
        .row
          .col-12.text v-html="texts[0]"
      .col-md-4.col-sm-12.paragraph
        .row
          .col-12.text v-html="texts[1]"
      .col-md-4.col-sm-12.paragraph
        .row
          .col-12.text v-html="texts[2]"
.article.row
  .col-12.paragraph
    h3 Recently Completed Projects
    .row
      .col-12.paragraph
        .row
          .col-12.text v-html="texts[3]"
      .col-12.paragraph
        .row
          .col-12.text v-html="texts[4]"
      .col-12.paragraph
        .row
          .col-12.text v-html="texts[5]"
      .col-12.paragraph
        .row
          .col-12.text v-html="texts[6]"
      .col-12.paragraph
        .row
          .col-12.text v-html="texts[7]"
      .col-12.paragraph
        .row
          .col-12.text v-html="texts[8]"
      .col-12.paragraph
        .row
          .col-12.text v-html="texts[9]"
      .col-12.paragraph
        .row
          .col-12.text v-html="texts[10]"
*/



// WEBPACK FOOTER //
// ./src/components/mixins/bz-tree-item.js